import LogoImage from '@assets/images/oddbox.svg';
import { MQ } from '@common/constants/mq.constant';
import { Image } from '@common/general-ui/image/image.component';
import { Link } from '@common/general-ui/link/link.component';
import { useScreenMediaQuery } from '@common/hooks/use-screen-media-query.hook';
import { t } from '@common/hooks/use-t.hook';
import { LINKS } from '@src/shared/links.constant';
import React from 'react';
import { css } from 'twin.macro';

interface IProps {
    text?: string;
    className?: string;
}
export const Logo = ({ text, className }: IProps): JSX.Element => {
    const { isDownLG } = useScreenMediaQuery();
    return (
        <Link className={className} href={LINKS.index} name="logo" tw="relative">
            {isDownLG ? (
                <Image alt="logo" src={LogoImage} width="109px" />
            ) : (
                <Image alt="logo" src={LogoImage} width="120px" />
            )}
            <div css={styles.logoText} tw="font-secondary uppercase">
                {text}
            </div>
        </Link>
    );
};

export const AdminLogo = (): JSX.Element => {
    return <Logo text={t('Admin')} />;
};

const styles = {
    logoText: css`
        position: absolute;
        color: black;
        right: 0%;
        top: 75%;
        font-size: 16px;
        ${MQ.lg} {
            top: 90%;
            font-size: 24px;
        }
    `,
};
